import Contact from '@/modules/info/views/ContactInfo.vue';
import Health from '@/modules/info/views/HealthInfo.vue';
import UserInfo from '@/modules/info/views/UserInfo.vue';

export const InfoRoutes = [
    {
        path: '/contact',
        component: Contact,
    },
    {
        path: '/health',
        component: Health,
    },
    {
        path: '/user',
        component: UserInfo,
    }
];
